export default __webpack_public_path__ + "static/media/wpmtest_standard.8847aa05.svg";